<template lang="pug">
div
  template(v-if="entry.isFolder")
    menu-item(:label="entry.name")
      menu-item(:label=`$t('walk')`, @click="walk(entry)")
      menu-separator
      component(:is="BookmarkEntry", v-for="child in entry.children", :key="Id(child)", :entry="child")
  template(v-else)
    menu-item(:label="entry.name", @click="goto")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { EquatorialCoord } from "@hscmap/angle";
import { BookmarkEntry, IBookmark, IBookmarkFolder } from "../";
import { walkBookmarks } from "../walk";
import { store } from '@/store';
import * as easing from '@hscmap/easing'

@Component
export default class BookmarkEntryComponent extends Vue {
  @Prop()
  entry!: BookmarkEntry

  goto() {
    const globe = store.currentGlobe()
    const { view } = this.entry as IBookmark
    const { a, d, fovy, roll } = view
    const coord = EquatorialCoord.fromRad(a, d)
    globe.viewFactory.jumpTo({ fovy, roll }, { coord, duration: 4000, easingFunction: easing.slowStartStop4 })
  }

  get BookmarkEntry() {
    return BookmarkEntryComponent
  }

  walk(folder: IBookmarkFolder) {
    walkBookmarks(folder, store, this.module)
  }

  get module() {
    return this.Store.modules.bookmark
  }
}
</script>

<i18n>
en:
  walk: Walk
ja:
  walk: 巡回

</i18n>